import React, { useEffect, useState } from 'react'
import classes from "../../styles.module.css";
import { useNavigate } from 'react-router-dom';
import TitleSection from '../../../../common/TitleSection';
import { Helmet } from 'react-helmet';
import { FullWidthWiraaAds } from '../../../../common/Ads/FullWidthWiraaAds';
import styles from "../../../../ContentStyling.module.css";

const CmToMiles = () => {
    const [inputValue, setInputValue] = useState();
    const [outputValue, setOutputValue] = useState();
    const [errorMessage, setErrorMessage] = useState();
    const navigate = useNavigate();

    useEffect(() => {
        // Initialize Google Ads
        try {
          (window.adsbygoogle = window.adsbygoogle || []).push({});
          console.error("AdSense run successfully");
        } catch (e) {
          console.error("AdSense error", e);
        }
      }, []);

      const convertCmToMiles = () => {
        // Validate input: allow numbers, decimals, and optional minus sign
        if (!/^-?\d+(\.\d+)?$/.test(inputValue)) {
            setErrorMessage("Please enter a valid length in centimeters (e.g., 160934, 321868.8).");
            setOutputValue("");
            return;
        }

        setErrorMessage("");
        const cmValue = parseFloat(inputValue); // Convert input string to a number
        const mileValue = cmValue / 160934; // 1 mile = 160,934 cm
        setOutputValue(mileValue.toFixed(6)); // Limit output to 6 decimal places
    };





      const handleClearBtn = () => {
        setInputValue("");
        setOutputValue("");
        setErrorMessage("");
      }

      const handleSwapClick = () => {
        navigate("/converters/miles-to-cm");
    };

        

  return (
    <div className={classes.page}>
      <Helmet>
                <title>CM to Miles Converter - Wiraa tools</title>
                <meta name="description" content="Easily convert Cm to miles using our online conversion tool. Accurate results with simple calculations for your length measurements. Try now!" />
        </Helmet>
    <div className={classes.container}>
      <TitleSection
              icon="https://cdn-icons-png.flaticon.com/128/570/570968.png"
              title="CM To Miles Converter"
              subTitle="Effortlessly Convert CM To Miles for Accurate Measurements"
            />
      <div className={classes.innerCon}>
        <div className={classes.inputCon}>
            <p className={classes.inputplaceholder}>CM Value</p>
            <input value={inputValue} onChange={(e) => setInputValue(e.target.value)} className={classes.inputfield} placeholder='Enter cm value'/>
            {errorMessage && <p className={classes.errorMsg}>{errorMessage}</p>}
        </div>
        <div className={classes.btnCon}>
            <button className={classes.convertBtn} onClick={convertCmToMiles}>Convert</button>
            <button className={classes.clearBtn} onClick={handleClearBtn}>Clear</button>
            <button className={classes.swapBtn} onClick={handleSwapClick}>Swap</button>
        </div>
        <div className={classes.outputCon}>
            <p className={classes.outputplaceholder}>Miles Value</p>
            <p className={classes.outputfield}>{outputValue}</p>
        </div>
      </div>
      <div className={classes.ads}>
        <FullWidthWiraaAds/>
     </div>
     <div className={styles.contentContainer}>
      <h3>Centimeters (cm)</h3>
      <p>Centimeters (cm) are a metric unit of length widely used around the world for everyday measurements. One centimeter equals one-hundredth of a meter (0.01 m). Centimeters are commonly used for measuring small distances, such as the dimensions of furniture, the height of a person, or lengths in construction and tailoring. For example, a pencil might be about 15 cm long, while a door’s width might be around 90 cm.</p>
      <h3>Miles (mi)</h3>
      <p>Miles (mi) are an imperial unit of length mainly used in the US, UK, and a few other countries for measuring long distances, especially in road travel and mapping. One mile equals 1,609.34 meters or 160,934 centimeters. Miles are often used for road signs, travel distances, and maps. For instance, the distance between two cities could be 50 miles, or a morning run might cover 3 miles.</p>
      <h3>How to Convert Centimeters to Miles</h3>
      <p>To convert centimeters to miles, use this formula: <br />
        <b>Miles (mi) = Centimeters (cm) ÷ 160,934</b> <br />
        For example, to convert 100,000 cm to miles: <br />
        <b>Miles (mi) = 100,000 ÷ 160,934 ≈ 0.62 mi</b> <br />
        Therefore, 100,000 cm is approximately 0.62 miles.
      </p>
      <h3>Centimeters to Miles Conversion Table</h3>
      <div className={styles.tableCon}>
        <table border="1" cellpadding="8" cellspacing="0">
          <thead>
            <tr>
              <th><b>Centimeters (cm)</b></th>
              <th><b>Miles (mi)</b></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1,000</td>
              <td>0.00062</td>
            </tr>
            <tr>
              <td>10,000</td>
              <td>0.0062</td>
            </tr>
            <tr>
              <td>50,000</td>
              <td>0.031</td>
            </tr>
            <tr>
              <td>100,000</td>
              <td>0.062</td>
            </tr>
            <tr>
              <td>500,000</td>
              <td>0.31</td>
            </tr>
            <tr>
              <td>1,000,000</td>
              <td>0.62</td>
            </tr>
            <tr>
              <td>10,000,000</td>
              <td>6.21</td>
            </tr>
          </tbody>
        </table>
      </div>
      <h3>Why Convert Centimeters to Miles?</h3>
      <p>Converting centimeters to miles is useful for travelers, engineers, and anyone working with both metric and imperial measurement systems. It helps compare measurements accurately in countries that prefer miles for long distances and centimeters for precise measurements. This conversion is often required in international projects, mapping, and global logistics.</p>
     </div>
    </div>
   </div>
  )
}

export default CmToMiles;
